export enum enumUserMultiFactorStatus {
    pending ='pending',
    confirmed = 'confirmed'
}

export namespace enumUserMultiFactorStatus {
    export function values() {
        return Object.keys(enumUserMultiFactorStatus).filter(
            (type) => isNaN(<any>type) && type !== 'values'
        );
    }
}


export enum enumUserMultiFactorAuthMethod {
    authentication ='authentication',
    guardian = 'guardian',
    sms = 'sms'
}

export namespace enumUserMultiFactorAuthMethod {
    export function values() {
        return Object.keys(enumUserMultiFactorAuthMethod).filter(
            (type) => isNaN(<any>type) && type !== 'values'
        );
    }
}

export interface UserMultiFactorEnrollment {
   id: string;
   status: enumUserMultiFactorStatus;
   type: string;
   name: string;
   identifier: string;
   phonenumber: string;
   authmethod: enumUserMultiFactorAuthMethod;
   enrolledat: string;
   lastauth: string;
}
